import { Pipe, PipeTransform } from "@angular/core";
import { TranslocoService } from "@ngneat/transloco";
import { ImportStatus } from "../model/statements/import-status";

@Pipe({
    name: 'importStatus',
    standalone: false
})
export class ImportStatusPipe implements PipeTransform {
  constructor(private translocoService: TranslocoService) {}

  transform = (importStatus?: ImportStatus): string => this.getTitle(importStatus);

  private getTitle = (importStatus?: ImportStatus): string => {
    switch (importStatus) {
      case ImportStatus.OPEN:
        return this.translocoService.translate(`account.statements.status.${ImportStatus.OPEN}`);
      case ImportStatus.CONFIRMED:
        return this.translocoService.translate(`account.statements.status.${ImportStatus.CONFIRMED}`);
      default:
        return "-";
    }
  }
}
